import {
  ApolloClient,
  createHttpLink,
  from,
  InMemoryCache,
  NormalizedCacheObject
} from '@apollo/client';
import env from '../../../utils/env';
import { setContext } from '@apollo/client/link/context';
import { authService } from '../../common/services';

const httpLink = (iseas: boolean = false) => { 
  if (iseas) {
    return createHttpLink({
      uri: env.easGqlUri
    });
  }
  return createHttpLink({
    uri: env.graphqlUri
  });
};
  

const authLink = setContext((_, { headers }) => {
  return {
    headers: {
      ...headers,
      'x-api-key': env.apiKey
    }
  };
});

const authLinkWithAuthorization = setContext((_, { headers }) => {
  return {
    headers: {
      ...headers,
      'x-api-key': env.apiKey,
      authorization: authService.getJWT() || 'invalid'
    }
  };
});

const client = (isAuthorziationRequired: boolean) => {
  if (isAuthorziationRequired) {
    return new ApolloClient({
      link: from([authLinkWithAuthorization, httpLink()]),
      cache: new InMemoryCache({ addTypename: false })
    });
  }
  return new ApolloClient({
    link: from([authLink, httpLink()]),
    cache: new InMemoryCache({ addTypename: false })
  });

};

const easRequestHeaders = setContext((_, { headers }) => {
  return {
    headers: {
      ...headers,
      'apollographql-client-name': 'cipautobody',
      'apollographql-client-version': 1,
      'source-client': 'cipautobody',
      authorization: authService.getJWT() || 'invalid'
    }
  };
});

const easClient = ()=> {
  return new ApolloClient({
    link: from([easRequestHeaders, httpLink(true)]),
    cache: new InMemoryCache({ addTypename: false })
  });
};

let publicAccountApolloClient: ApolloClient<NormalizedCacheObject> | undefined;

const publicAccountClient = () => {
  if (!publicAccountApolloClient) {
    publicAccountApolloClient = new ApolloClient({
      link: createHttpLink({
        uri: env.publicAccountGqlUri,
        credentials: 'omit'
      }),
      cache: new InMemoryCache({ addTypename: false })
    });
  }
  return publicAccountApolloClient;
};

export { client, easClient, publicAccountClient };
